import Sidebar from "../components/sidebar/Sidebar";
import Topbar from "../components/topbar/Topbar";
import "../App.css";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";


import ResetPassword from "../pages/landingPage/resetPassword";
import LandingMembership from "../pages/landingPage/membership";
import EmailValidation from "../pages/landingPage/emailValidation";
import ActivateMemberAccount from "../pages/landingPage/activateMemberAccount";
import page404 from "../pages/landingPage/404";
import CerificateValidation from '../pages/landingPage/certificateValidation'



//Application Individiual pages 
import ApplicationChoosenClass from "../pages/applicantForms/applicationChoosenClass";
import ApplicationPersonaldetails from "../pages/applicantForms/applicationPersonaldetails";
import ApplicationContactDetails from "../pages/applicantForms/applicationContactDetails";
import ApplicationEducationalDetails from "../pages/applicantForms/applicationEducationalDetails";
import ApplicationCertificationDetails from "../pages/applicantForms/applicationCertificationDetails"
import ApplicationReviewDetails from "../pages/applicantForms/applicationReviewDetails";
import ApplicationReferenceDetails from "../pages/applicantForms/applicationReferenceDetails";
import ApllicationPaymentDetails from "../pages/applicantForms/applicationPaymentDetails";
import SuccessfulPayment from "../pages/applicantForms/successfulPayment";


//Application Company pages 
import CompanyDetails from "../pages/applicantForms/company/companyDetails";
import CompanyContactDetails from "../pages/applicantForms/company/companyContactDetails";
import CompanyShareHoldersDetails from "../pages/applicantForms/company/companyShareholdersdetails";
import CompanyProjectDetails from "../pages/applicantForms/company/companyProjectDetails";
import CompanyAttachments from "../pages/applicantForms/company/companyAttachments";
import FirmApplicationDetails from "../pages/applicantForms/company/companyApplicationReview";
import FirmApplicationStatus from "../pages/myApplication/firmApplicationStatus";


//pages
import Dashboard from "../pages/dashboard";
import Application from '../pages/myApplication'
import Payments from '../pages/payments'
import MembershipPage from "../pages/membership";
import Calender from '../pages/calender'
import Profile from '../pages/myProfile'
import PaymentScreen from '../pages/membership/paymentScreen'
import ApplicationStatus from '../pages/myApplication/applicationStatus'
import Billers from "../pages/billers";


//protectedRoutes component
import ProtectedRoutes from "./protectedRoutes";



function Routes() {
  return (
    <Router>
        <Switch>
          <Route exact path="/" component={LandingMembership}/>
          {/* <Route exact path="/landing-page" component={LandingMembership}/> */}
          <Route exact path="/home" component={LandingMembership}/>
          <Route exact path="/reset-password" component={ResetPassword}/>
          <Route exact path="/activate/email" component={EmailValidation}/>
          <Route exact path="/activate/memberaccount" component={ActivateMemberAccount}/>
          <Route exact path="/validation/certificate" component={CerificateValidation}/>
          {/* <Route path="*" exact component={page404}/> */}
        <div>
          <Topbar/>
          <div className="d-flex">
          <Sidebar />
          <div className="main">
          <ProtectedRoutes path="/applicant" exact component={ApplicationChoosenClass}/>
          <ProtectedRoutes path="/applicant/personal-details" component={ApplicationPersonaldetails}/>
          <ProtectedRoutes path="/member/personal-details" component={ApplicationPersonaldetails}/>
          <ProtectedRoutes path="/test/personal-details" component={ApplicationPersonaldetails}/>

          <ProtectedRoutes path="/applicant/contact-details" component={ApplicationContactDetails}/>
          <ProtectedRoutes path="/member/contact-details" component={ApplicationContactDetails}/>
          <ProtectedRoutes path="/applicant/educational-details" component={ApplicationEducationalDetails}/>
          <ProtectedRoutes path="/member/educational-details" component={ApplicationEducationalDetails}/>
          <ProtectedRoutes path="/applicant/certificate-details" component={ApplicationCertificationDetails}/>
          <ProtectedRoutes path="/member/certificate-details" component={ApplicationCertificationDetails}/>
          <ProtectedRoutes path="/applicant/reference-details" component={ApplicationReferenceDetails}/>
          <ProtectedRoutes path="/member/reference-details" component={ApplicationReferenceDetails}/>

          <ProtectedRoutes path="/applicant/review-details" component={ApplicationReviewDetails}/>
          <ProtectedRoutes path="/applicant/payment-details" component={ApllicationPaymentDetails}/>
          <ProtectedRoutes path="/applicant/bank-transfers" component={SuccessfulPayment}/>


          <ProtectedRoutes path="/applicant/company/details" component={CompanyDetails}/>
          <ProtectedRoutes path="/applicant/company/contacts" component={CompanyContactDetails}/>
          <ProtectedRoutes path="/applicant/company/shareholders" component={CompanyShareHoldersDetails}/>
          <ProtectedRoutes path="/applicant/company/projects" component={CompanyProjectDetails}/>
          <ProtectedRoutes path="/applicant/company/attachments" component={CompanyAttachments}/>
          <ProtectedRoutes path="/applicant/company/review-details" component={FirmApplicationDetails}/>
          <ProtectedRoutes path="/applicant/company/payment-details" component={ApllicationPaymentDetails}/>
          
          

          <ProtectedRoutes path="/dashboard" component={Dashboard}/>
          <ProtectedRoutes path="/application" exact component={Application}/>
          <ProtectedRoutes path="/application/status" component={ApplicationStatus}/>
          <ProtectedRoutes path="/application/firm-status" component={FirmApplicationStatus}/>
          <ProtectedRoutes path="/payments" component={Payments}/>
          <ProtectedRoutes path="/billers" component={Billers}/>
          <ProtectedRoutes path="/membership" exact component={MembershipPage}/>
          <ProtectedRoutes path="/membership/payment" component={PaymentScreen}/>
          <ProtectedRoutes path="/calender" component={Calender}/>
          <ProtectedRoutes path="/profile" component={Profile}/>
        </div>
        </div>
      </div>
      </Switch>
    </Router>
  );
}

export default Routes;